import { render } from "./MobileView.vue?vue&type=template&id=6552ac02&ts=true"
import script from "./MobileView.vue?vue&type=script&lang=ts"
export * from "./MobileView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__